import { defineMessages } from 'react-intl';

export default defineMessages({
	errorMessage: {
		defaultMessage: "We couldn't load this field. Refresh the page to try again.",
		description: 'Error message shown when entitlements fail to be fetched',
		id: 'cv.request.create.form.entitlement-picker.error-message',
	},
});
